import {defineMessages} from 'react-intl';
import type {MessageDescriptor} from 'react-intl';
import type {OpenapiPostV1CryptoInternalRelayQuoteInputInputChainEnum} from '@stripe-internal/data-v1/schema/types';

export type UsdcNetwork = Exclude<
  OpenapiPostV1CryptoInternalRelayQuoteInputInputChainEnum,
  'bitcoin'
>;

export type NetworkInfo = {
  network: UsdcNetwork;
  processingTimeMessage: MessageDescriptor;
};

const messages = defineMessages({
  ethProcessingTime: {
    id: 'crypto.payins.v2.network_select.eth_processing_time',
    description: 'Processing time for Ethereum network',
    defaultMessage: 'Process in 1–5 mins',
  },
  fastProcessingTime: {
    id: 'crypto.payins.v2.network_select.fast_processing_time',
    description: 'Processing time for fast networks (Polygon, Base, Solana)',
    defaultMessage: 'Process in <30 secs',
  },
});

export const USDC_NETWORK_INFO_MAP: Record<
  UsdcNetwork,
  Omit<NetworkInfo, 'network'>
> = {
  ethereum: {processingTimeMessage: messages.ethProcessingTime},
  polygon: {processingTimeMessage: messages.fastProcessingTime},
  base: {processingTimeMessage: messages.fastProcessingTime},
  solana: {processingTimeMessage: messages.fastProcessingTime},
};
